import React, { useCallback, useEffect, useMemo, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

const DBAPI_KEY = process.env.REACT_APP_DBAPI_KEY;
const DBAPI_BASE_URL =
  process.env.REACT_APP_DBAPI_URL || "https://dbapi.twodots.cloud/api/flexrec";
const ACTION_WEBHOOK_URL =
  process.env.REACT_APP_ACTION_WEBHOOK_URL ||
  "https://n8n.twodots.cloud/webhook/findjobs";
const LINK_STORAGE_KEY = "collectedLinks";

const TAB_DEFINITIONS = [
  { key: "collection", label: "Link Collection" },
  { key: "captures", label: "Captured Links" },
  { key: "cv", label: "CV + Actions" },
  { key: "instructions", label: "Instructions" }
];

const ACTIVITY_OPTIONS = [
  { value: "company_list", label: "Company List" },
  { value: "contact_list", label: "Contact List" },
  { value: "job_list", label: "Jobs List" },
  { value: "prepare_email", label: "Prepare Email" },
  { value: "cv_summary", label: "CV Summary" },
  { value: "full_summary", label: "Full Summary" }
];

const FILTER_TYPES = [
  { value: "all", label: "All Types" },
  { value: "feed", label: "Feed Posts" },
  { value: "job", label: "Jobs" },
  { value: "company", label: "Companies" },
  { value: "person", label: "People" },
  { value: "maps", label: "Maps" },
  { value: "search", label: "Search Results" }
];

/* eslint-disable no-script-url, no-useless-escape */
const BOOKMARKLETS = [
  {
    title: "Google Search",
    description: "Adds checkboxes next to search results so you can send curated links in one click.",
    code: `javascript:(function(){var selectedItems=new Set();function updateCounter(){var count=selectedItems.size;var counter=document.getElementById('collectorCounter');if(counter){counter.textContent=count+' selected';counter.style.background=count>0?'#34a853':'#5f6368';}}var links=document.querySelectorAll('a[href]');links.forEach(function(link){var href=link.href;if(href&&!href.includes('google.com/search')&&!href.includes('accounts.google.com')&&!href.includes('google.com/aclk')&&!href.startsWith('javascript:')&&link.textContent.trim()){var checkbox=document.createElement('input');checkbox.type='checkbox';checkbox.style.cssText='margin-right:8px;transform:scale(1.5);cursor:pointer;';checkbox.dataset.url=href;checkbox.dataset.title=link.textContent.trim().substring(0,200);checkbox.dataset.type='Google Search';checkbox.addEventListener('change',function(){var key=href+'|||'+checkbox.dataset.title+'|||Google Search';if(checkbox.checked){selectedItems.add(key);}else{selectedItems.delete(key);}updateCounter();});link.parentNode.insertBefore(checkbox,link);}});if(document.getElementById('linkCollectorPanel'))return;var panel=document.createElement('div');panel.id='linkCollectorPanel';panel.style.cssText='position:fixed;bottom:20px;right:20px;background:#fff;border:2px solid #4285f4;padding:20px;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.3);z-index:999999;min-width:280px;';panel.innerHTML='<h3 style="margin:0 0 10px 0;color:#202124;font-size:16px;">Link Collector</h3><div style="margin-bottom:15px;color:#5f6368;font-size:12px;padding:8px;background:#f1f3f4;border-radius:4px;"><strong>Google Search</strong><br><span style="font-size:11px;">Check boxes to select</span></div><div id="collectorCounter" style="background:#5f6368;color:white;padding:8px;border-radius:4px;text-align:center;margin-bottom:10px;font-weight:600;font-size:14px;">0 selected</div><button id="sendLinks" style="background:#4285f4;color:#fff;border:none;padding:10px 20px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:14px;font-weight:600;">Send Selected Links</button><button id="openCollection" style="background:#34a853;color:#fff;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:13px;">Open Collection Page</button><button id="closePanel" style="background:#f1f3f4;color:#202124;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;font-size:13px;">Close</button>';document.body.appendChild(panel);document.getElementById('openCollection').onclick=function(){window.open('https://www.twodots.cloud/?page=linkCollector','linkCollection');};document.getElementById('sendLinks').onclick=function(){if(selectedItems.size===0){alert('Please select at least one item');return;}var selected=Array.from(selectedItems).map(function(item){var parts=item.split('|||');return{url:parts[0],title:parts[1],timestamp:new Date().toISOString(),source:parts[2],type:parts[2]};});var encodedData=encodeURIComponent(JSON.stringify(selected));var win=window.open('https://www.twodots.cloud/?page=linkCollector&data='+encodedData,'_blank');if(win){win.blur();window.focus();setTimeout(function(){win.close();},2000);}alert('Sent '+selected.length+' links!');selectedItems.clear();document.querySelectorAll('input[type="checkbox"][data-url]').forEach(function(cb){cb.checked=false;});updateCounter();};document.getElementById('closePanel').onclick=function(){panel.remove();document.querySelectorAll('input[type="checkbox"][data-url]').forEach(function(cb){cb.remove();});};})();`
  },
  {
    title: "Google Maps",
    description: "Treats each place card as a selectable capture and ships it to the Link Collector.",
    code: `javascript:(function(){var selectedItems=new Set();function addClickableSelection(element,url,title,rating,type){if(element.dataset.collectorEnabled)return;element.dataset.collectorEnabled='true';var originalBorder=element.style.border||'';var originalBackground=element.style.background||'';var originalBoxShadow=element.style.boxShadow||'';element.style.transition='all 0.3s ease';element.style.cursor='pointer';element.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var key=url+'|||'+title+'|||'+rating+'|||'+type;if(selectedItems.has(key)){selectedItems.delete(key);element.style.border=originalBorder;element.style.background=originalBackground;element.style.boxShadow=originalBoxShadow;if(element.checkmark){element.checkmark.remove();delete element.checkmark;}}else{selectedItems.add(key);element.style.border='3px solid #4285f4';element.style.background='rgba(66,133,244,0.1)';element.style.boxShadow='0 0 10px rgba(66,133,244,0.5)';if(!element.checkmark){var checkmark=document.createElement('div');checkmark.style.cssText='position:absolute;top:10px;right:10px;background:#4285f4;color:white;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:bold;z-index:10000;box-shadow:0 2px 8px rgba(0,0,0,0.5);pointer-events:none;';checkmark.textContent='✓';element.checkmark=checkmark;if(!element.style.position||element.style.position==='static'){element.style.position='relative';}element.appendChild(checkmark);}}updateCounter();},true);}function updateCounter(){var count=selectedItems.size;var counter=document.getElementById('collectorCounter');if(counter){counter.textContent=count+' selected';counter.style.background=count>0?'#34a853':'#5f6368';}}setTimeout(function(){var processed=new Set();var links=document.querySelectorAll('a[href*="/maps/place/"]');links.forEach(function(link){if(link.offsetHeight===0)return;var card=link.closest('div[role="article"]')||link.closest('div.Nv2PK')||link.parentElement;if(card&&!processed.has(card)&&!card.dataset.collectorEnabled){processed.add(card);var title='';var nameEl=card.querySelector('div.fontHeadlineSmall, div.qBF1Pd.fontHeadlineSmall');if(nameEl){title=nameEl.innerText.trim();}if(!title){var imgEl=card.querySelector('[role="img"]');if(imgEl){title=imgEl.getAttribute('aria-label')||'';}}if(!title){var h=card.querySelector('h3, h2, [role="heading"]');if(h)title=h.innerText.trim();}if(!title){title=link.innerText.trim().substring(0,80)||'Place';}var rating='No rating';var ratingEl=card.querySelector('span[role="img"][aria-label*="star"]');if(ratingEl){var ariaLabel=ratingEl.getAttribute('aria-label');var match=ariaLabel.match(/(\d+\.?\d*)\s*star/i);if(match){rating=match[1]+' stars';}}if(rating==='No rating'){var ratingSpan=card.querySelector('span.MW4etd');if(ratingSpan){rating=ratingSpan.innerText.trim()+' stars';}}addClickableSelection(card,link.href,title,rating,'Google Maps');}});},1500);if(document.getElementById('linkCollectorPanel'))return;var panel=document.createElement('div');panel.id='linkCollectorPanel';panel.style.cssText='position:fixed;bottom:20px;right:20px;background:#fff;border:2px solid #4285f4;padding:20px;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.3);z-index:999999;min-width:280px;';panel.innerHTML='<h3 style="margin:0 0 10px 0;color:#202124;font-size:16px;">Link Collector</h3><div style="margin-bottom:15px;color:#5f6368;font-size:12px;padding:8px;background:#f1f3f4;border-radius:4px;"><strong>Google Maps</strong><br><span style="font-size:11px;">Click cards to select</span></div><div id="collectorCounter" style="background:#5f6368;color:white;padding:8px;border-radius:4px;text-align:center;margin-bottom:10px;font-weight:600;font-size:14px;">0 selected</div><button id="sendLinks" style="background:#4285f4;color:#fff;border:none;padding:10px 20px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:14px;font-weight:600;">Send Selected Links</button><button id="openCollection" style="background:#34a853;color:#fff;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:13px;">Open Collection Page</button><button id="closePanel" style="background:#f1f3f4;color:#202124;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;font-size:13px;">Close</button>';document.body.appendChild(panel);document.getElementById('openCollection').onclick=function(){window.open('https://www.twodots.cloud/?page=linkCollector','linkCollection');};document.getElementById('sendLinks').onclick=function(){if(selectedItems.size===0){alert('Please select at least one item');return;}var selected=Array.from(selectedItems).map(function(item){var parts=item.split('|||');return{url:parts[0],title:parts[1],rating:parts[2],timestamp:new Date().toISOString(),source:parts[3],type:parts[3]};});var encodedData=encodeURIComponent(JSON.stringify(selected));var win=window.open('https://www.twodots.cloud/?page=linkCollector&data='+encodedData,'_blank');if(win){win.blur();window.focus();setTimeout(function(){win.close();},2000);}alert('Sent '+selected.length+' links!');selectedItems.clear();document.querySelectorAll('[data-collector-enabled]').forEach(function(el){el.style.border='';el.style.background='';el.style.boxShadow='';delete el.dataset.collectorEnabled;if(el.checkmark)el.checkmark.remove();});updateCounter();};document.getElementById('closePanel').onclick=function(){panel.remove();document.querySelectorAll('[data-collector-enabled]').forEach(function(el){el.style.border='';el.style.background='';el.style.boxShadow='';delete el.dataset.collectorEnabled;if(el.checkmark)el.checkmark.remove();});};})();`
  },
  {
    title: "XING",
    description: "Highlights XING profile, company, and job cards so you can curate everything with one send.",
    code: `javascript:(function(){var selectedItems=new Set();function addClickableSelection(element,url,title,type){if(element.dataset.collectorEnabled)return;element.dataset.collectorEnabled='true';var originalBorder=element.style.border||'';var originalBackground=element.style.background||'';var originalBoxShadow=element.style.boxShadow||'';element.style.transition='all 0.3s ease';element.style.cursor='pointer';element.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();var key=url+'|||'+title+'|||'+type;if(selectedItems.has(key)){selectedItems.delete(key);element.style.border=originalBorder;element.style.background=originalBackground;element.style.boxShadow=originalBoxShadow;if(element.checkmark){element.checkmark.remove();delete element.checkmark;}}else{selectedItems.add(key);element.style.border='3px solid #026466';element.style.background='rgba(2,100,102,0.1)';element.style.boxShadow='0 0 10px rgba(2,100,102,0.5)';if(!element.checkmark){var checkmark=document.createElement('div');checkmark.style.cssText='position:absolute;top:10px;right:10px;background:#026466;color:white;width:30px;height:30px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:bold;z-index:10000;box-shadow:0 2px 8px rgba(0,0,0,0.5);pointer-events:none;';checkmark.textContent='✓';element.checkmark=checkmark;if(!element.style.position||element.style.position==='static'){element.style.position='relative';}element.appendChild(checkmark);}}updateCounter();},true);}function updateCounter(){var count=selectedItems.size;var counter=document.getElementById('collectorCounter');if(counter){counter.textContent=count+' selected';counter.style.background=count>0?'#026466':'#5f6368';}}function findCard(link){var card=link.closest('article')||link.closest('li')||link.closest('[class*="card"]')||link.closest('[class*="Card"]');if(!card){var parent=link.parentElement;var depth=0;while(parent&&depth<8){var rect=parent.getBoundingClientRect();if(rect.height>80&&rect.height<500){card=parent;break;}parent=parent.parentElement;depth++;}}return card||link.parentElement;}function extractNameFromUrl(url,type){try{var urlParts=url.split('/');var name='';if(type==='XING Person'){for(var i=0;i<urlParts.length;i++){if(urlParts[i]==='profile'&&urlParts[i+1]){name=urlParts[i+1];break;}}}else if(type==='XING Company'){for(var i=0;i<urlParts.length;i++){if((urlParts[i]==='pages'||urlParts[i]==='companies'||urlParts[i]==='company')&&urlParts[i+1]){name=urlParts[i+1];break;}}}else if(type==='XING Job'){for(var i=0;i<urlParts.length;i++){if((urlParts[i]==='jobs'||urlParts[i]==='job')&&urlParts[i+1]){name=urlParts[i+1];break;}}}if(name){name=name.replace(/-/g,' ').replace(/_/g,' ');name=name.split('?')[0];name=name.replace(/\b\w/g,function(l){return l.toUpperCase();});return name;}return'';}catch(e){return'';}}function extractTitle(link,card,type,url){var title='';if(type==='XING Person'){var heading=card.querySelector('h3, h2, [class*="name"], [class*="Name"]')||link.querySelector('h3, h2, [class*="name"], [class*="Name"]');if(heading)title=heading.innerText.trim();if(!title){var nameSpans=card.querySelectorAll('span');for(var i=0;i<nameSpans.length;i++){var text=nameSpans[i].innerText.trim();if(text.length>5&&text.length<50&&text.match(/^[A-Z]/)){title=text;break;}}}}else if(type==='XING Company'){var heading=card.querySelector('h3, h2, h4, [class*="company"], [class*="Company"], [class*="name"], [class*="Name"]')||link.querySelector('h3, h2, h4');if(heading)title=heading.innerText.trim();if(!title){var allText=card.innerText.trim().split('\n');for(var i=0;i<allText.length;i++){var text=allText[i].trim();if(text.length>3&&text.length<100&&!text.match(/^(See|View|Follow|Connect|About|Jobs|People)/i)){title=text;break;}}}}else if(type==='XING Job'){title=link.innerText.trim();if(!title){var heading=card.querySelector('h3, h2, h4');if(heading)title=heading.innerText.trim();}}if(!title||title.length<3){title=link.innerText.trim();}if(!title||title.length<3){var urlName=extractNameFromUrl(url,type);if(urlName)title=urlName;}if(!title||title.length<3){title=card.innerText.trim().substring(0,100);}if(!title||title.length<3){title=type;}return title.substring(0,150);}function extractAll(){var allLinks=document.querySelectorAll('a[href]');var processed=new Set();allLinks.forEach(function(link){var href=link.href;var type='';var isRelevant=false;if(href.includes('/jobs/')||href.includes('/job/')){type='XING Job';isRelevant=true;}else if(href.includes('/pages/')||href.includes('/companies/')||href.includes('/company/')){type='XING Company';isRelevant=true;}else if(href.includes('/profile/')){type='XING Person';isRelevant=true;}if(isRelevant&&link.offsetHeight>0){var card=findCard(link);if(card&&!processed.has(card)&&!card.dataset.collectorEnabled){processed.add(card);var fullUrl=href.startsWith('http')?href:'https://www.xing.com'+href;var title=extractTitle(link,card,type,fullUrl);addClickableSelection(card,fullUrl,title,type);}}});}setTimeout(function(){extractAll();},2000);var observer=new MutationObserver(function(){extractAll();});observer.observe(document.body,{childList:true,subtree:true});setTimeout(function(){observer.disconnect();},10000);if(document.getElementById('linkCollectorPanel'))return;var panel=document.createElement('div');panel.id='linkCollectorPanel';panel.style.cssText='position:fixed;bottom:20px;right:20px;background:#fff;border:2px solid #026466;padding:20px;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,0.3);z-index:999999;min-width:280px;';panel.innerHTML='<h3 style="margin:0 0 10px 0;color:#202124;font-size:16px;">Link Collector</h3><div style="margin-bottom:15px;color:#5f6368;font-size:12px;padding:8px;background:#f1f3f4;border-radius:4px;"><strong>XING</strong><br><span style="font-size:11px;">Click cards to select</span></div><div id="collectorCounter" style="background:#5f6368;color:white;padding:8px;border-radius:4px;text-align:center;margin-bottom:10px;font-weight:600;font-size:14px;">0 selected</div><button id="sendLinks" style="background:#026466;color:#fff;border:none;padding:10px 20px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:14px;font-weight:600;">Send Selected Links</button><button id="openCollection" style="background:#34a853;color:#fff;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;margin-bottom:8px;font-size:13px;">Open Collection Page</button><button id="closePanel" style="background:#f1f3f4;color:#202124;border:none;padding:8px 16px;border-radius:4px;cursor:pointer;width:100%;font-size:13px;">Close</button>';document.body.appendChild(panel);document.getElementById('openCollection').onclick=function(){window.open('https://www.twodots.cloud/?page=linkCollector','linkCollection');};document.getElementById('sendLinks').onclick=function(){if(selectedItems.size===0){alert('Please select at least one item');return;}var selected=Array.from(selectedItems).map(function(item){var parts=item.split('|||');return{url:parts[0],title:parts[1],timestamp:new Date().toISOString(),source:parts[2],type:parts[2]};});var encodedData=encodeURIComponent(JSON.stringify(selected));var win=window.open('https://www.twodots.cloud/?page=linkCollector&data='+encodedData,'_blank');if(win){win.blur();window.focus();setTimeout(function(){win.close();},2000);}alert('Sent '+selected.length+' links!');selectedItems.clear();document.querySelectorAll('[data-collector-enabled]').forEach(function(el){el.style.border='';el.style.background='';el.style.boxShadow='';delete el.dataset.collectorEnabled;if(el.checkmark)el.checkmark.remove();});updateCounter();};document.getElementById('closePanel').onclick=function(){panel.remove();document.querySelectorAll('[data-collector-enabled]').forEach(function(el){el.style.border='';el.style.background='';el.style.boxShadow='';delete el.dataset.collectorEnabled;if(el.checkmark)el.checkmark.remove();});};})();`
  }
];
/* eslint-enable no-script-url, no-useless-escape */

const buildHeaders = (json = true) => {
  const headers = {};
  if (json) {
    headers["Content-Type"] = "application/json";
  }
  if (DBAPI_KEY) {
    headers["x-api-key"] = DBAPI_KEY;
  }
  return headers;
};

const normalizeEditedLink = (link) => {
  if (!link || !link.url) {
    return null;
  }
  return {
    id: `${link.url}-${link.title || link.timestamp || Date.now()}`,
    url: link.url,
    title: link.title || link.url,
    snippet: link.snippet || "",
    hoverText: link.hoverText || link.hover_text || "",
    source: link.source || link.type || "Link Collector",
    type: link.type || link.source || "Link",
    timestamp: link.timestamp || new Date().toISOString(),
    metadata: link.metadata || null
  };
};

const readStoredLinks = () => {
  if (typeof window === "undefined") {
    return [];
  }
  try {
    const raw = window.localStorage.getItem(LINK_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (error) {
    console.error("LinkCollector: failed to read stored links", error);
    return [];
  }
};

const writeStoredLinks = (links) => {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(LINK_STORAGE_KEY, JSON.stringify(links));
};

const dedupeLinks = (links) => {
  const seen = new Set();
  return links.filter((link) => {
    if (!link) return false;
    const key = `${link.url}|||${link.title}|||${link.source}`;
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

const parseBookmarkletPayload = (encoded) => {
  try {
    const decoded = JSON.parse(decodeURIComponent(encoded));
    if (Array.isArray(decoded)) {
      return decoded;
    }
    if (decoded && typeof decoded === "object") {
      return [decoded];
    }
  } catch (error) {
    console.error("LinkCollector: unable to parse bookmarklet payload", error);
  }
  return [];
};

const parseMessagePayload = (payload) => {
  if (!payload || typeof payload !== "object") {
    return [];
  }
  if (payload.url) {
    return [
      {
        url: payload.url,
        title: payload.label || payload.title || payload.url,
        snippet: payload.snippet,
        hoverText: payload.hoverText || payload.hover_text,
        source: payload.source_type || payload.source || payload.type,
        type: payload.type || payload.source_type || payload.source,
        timestamp: payload.timestamp || payload.capturedAt || new Date().toISOString()
      }
    ];
  }
  return [];
};

const mapLinkToCapturePayload = (link) => {
  const payload = {
    url: link.url,
    label: link.title || link.url
  };
  if (link.snippet) {
    payload.snippet = link.snippet;
  }
  if (link.hoverText) {
    payload.hover_text = link.hoverText;
  }
  if (link.source) {
    payload.source_type = link.source;
  }
  if (link.timestamp) {
    payload.captured_at = link.timestamp;
  }
  return payload;
};

const normalizeBookmarkletCode = (value) => value.replace(/\s+/g, " ").trim();

const formatToLocalDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const timezoneOffset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - timezoneOffset * 60000);
  return localDate.toISOString().slice(0, 16);
};

const parseWebhookResponse = (payload) => {
  if (!payload || typeof payload !== "object") {
    return String(payload);
  }
  if (payload.body) {
    return payload.body;
  }
  const keys = ["output", "response", "message", "text", "result", "data"];
  for (const key of keys) {
    if (key in payload && payload[key]) {
      return payload[key];
    }
  }
  return JSON.stringify(payload, null, 2);
};

function FindJobsPage() {
  const [activeTab, setActiveTab] = useState("collection");
  const [projects, setProjects] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState("");
  const [pendingLinks, setPendingLinks] = useState([]);
  const [captures, setCaptures] = useState([]);
  const [filterSource, setFilterSource] = useState("all");
  const [filterType, setFilterType] = useState("all");
  const [projectName, setProjectName] = useState("");
  const [isCreatingProject, setIsCreatingProject] = useState(false);
  const [saveMessage, setSaveMessage] = useState("");
  const [isSavingAll, setIsSavingAll] = useState(false);
  const [projectDraft, setProjectDraft] = useState({
    name: "",
    ownerId: "",
    metadataJson: "{}"
  });
  const [projectStatus, setProjectStatus] = useState("");
  const [captureStatus, setCaptureStatus] = useState("");
  const [activeCaptureSource, setActiveCaptureSource] = useState("all");
  const [captureEdits, setCaptureEdits] = useState({});
  const [captureSavingId, setCaptureSavingId] = useState(null);
  const [cvFile, setCvFile] = useState(null);
  const [cvStatus, setCvStatus] = useState("");
  const [selectedActivity, setSelectedActivity] = useState(ACTIVITY_OPTIONS[0].value);
  const [actionResult, setActionResult] = useState("");
  const [actionStatus, setActionStatus] = useState("");
  const [actionLoading, setActionLoading] = useState(false);
  const [copiedBookmarklet, setCopiedBookmarklet] = useState("");

  const selectedProject = useMemo(
    () => projects.find((project) => project.id === selectedProjectId) || null,
    [projects, selectedProjectId]
  );

  const savedCaptureUrls = useMemo(() => new Set(captures.map((capture) => capture.url)), [captures]);

  const pendingWithStatus = useMemo(() => {
    const sorted = [...pendingLinks].sort(
      (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
    return sorted.map((link) => ({
      ...link,
      saved: savedCaptureUrls.has(link.url)
    }));
  }, [pendingLinks, savedCaptureUrls]);

  const filteredPendingLinks = useMemo(() => {
    return pendingWithStatus.filter((link) => {
      const platform = (link.source || link.type || "").toLowerCase();
      const type = (link.type || link.source || "").toLowerCase();
      if (filterSource !== "all" && platform !== filterSource.toLowerCase()) {
        return false;
      }
      if (filterType !== "all" && !type.includes(filterType)) {
        return false;
      }
      return true;
    });
  }, [pendingWithStatus, filterSource, filterType]);

  const collectionSources = useMemo(() => {
    const seen = new Set();
    const list = pendingLinks.map((link) => link.source || link.type || "Other");
    list.forEach((source) => seen.add(source));
    return ["all", ...Array.from(seen)];
  }, [pendingLinks]);

  const captureSourceTabs = useMemo(() => {
    const sources = new Set();
    captures.forEach((capture) => {
      sources.add(capture.source_type || "Unknown");
    });
    return ["all", ...Array.from(sources)];
  }, [captures]);

  useEffect(() => {
    if (!captureSourceTabs.includes(activeCaptureSource)) {
      setActiveCaptureSource("all");
    }
  }, [captureSourceTabs, activeCaptureSource]);

  const filteredCaptures = useMemo(() => {
    if (activeCaptureSource === "all") {
      return captures;
    }
    return captures.filter(
      (capture) => (capture.source_type || "Unknown") === activeCaptureSource
    );
  }, [captures, activeCaptureSource]);

  const fetchProjects = useCallback(() => {
    fetch(`${DBAPI_BASE_URL}/projects`, { headers: buildHeaders(false) })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data) => {
        if (Array.isArray(data)) {
          setProjects(data);
          setSelectedProjectId((prev) => prev || data[0]?.id || "");
        }
      })
      .catch((error) => {
        console.error("LinkCollector: failed to load projects", error);
        setProjectStatus("Unable to load projects yet.");
      });
  }, []);

  const fetchCaptures = useCallback(() => {
    if (!selectedProjectId) {
      setCaptures([]);
      return;
    }
    fetch(`${DBAPI_BASE_URL}/projects/${selectedProjectId}/captures`, {
      headers: buildHeaders(false)
    })
      .then((res) => (res.ok ? res.json() : Promise.reject(res.statusText)))
      .then((data) => {
        if (Array.isArray(data)) {
          setCaptures(data);
        }
      })
      .catch((error) => {
        console.error("LinkCollector: failed to load captures", error);
        setCaptureStatus("Unable to load captures.");
      });
  }, [selectedProjectId]);

  const mergeIncomingLinks = useCallback(
    (incoming) => {
      if (!incoming?.length) return;
      const normalized = incoming
        .map((payload) => normalizeEditedLink(payload))
        .filter(Boolean);
      if (!normalized.length) return;
      const existing = readStoredLinks();
      const combined = dedupeLinks([...normalized, ...existing]);
      writeStoredLinks(combined);
      setPendingLinks(combined);
    },
    []
  );

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  useEffect(() => {
    fetchCaptures();
  }, [fetchCaptures]);

  useEffect(() => {
    if (!selectedProject) {
      setProjectDraft({ name: "", ownerId: "", metadataJson: "{}" });
      return;
    }
    setProjectDraft({
      name: selectedProject.name,
      ownerId: selectedProject.owner_id || "",
      metadataJson: JSON.stringify(selectedProject.metadata || {}, null, 2)
    });
  }, [selectedProject]);

  useEffect(() => {
    const stored = readStoredLinks();
    setPendingLinks(stored);
    if (typeof window === "undefined") {
      return undefined;
    }
    const params = new URLSearchParams(window.location.search);
    const encoded = params.get("data");
    if (encoded) {
      const links = parseBookmarkletPayload(encoded);
      mergeIncomingLinks(links);
      const base = window.location.pathname;
      window.history.replaceState({}, "", `${base}?page=linkCollector`);
    }
    const messageHandler = (event) => {
      const incoming = parseMessagePayload(event.data);
      if (incoming.length) {
        mergeIncomingLinks(incoming);
        setSaveMessage(`Received ${incoming.length} bookmarklet capture(s).`);
      }
    };
    window.addEventListener("message", messageHandler);
    const interval = window.setInterval(() => {
      const latest = readStoredLinks();
      setPendingLinks(latest);
    }, 2500);
    return () => {
      window.removeEventListener("message", messageHandler);
      window.clearInterval(interval);
    };
  }, [mergeIncomingLinks]);

  const handleCreateProject = async (event) => {
    event.preventDefault();
    const trimmed = projectName.trim();
    if (!trimmed) {
      return;
    }
    setIsCreatingProject(true);
    try {
      const response = await fetch(`${DBAPI_BASE_URL}/projects`, {
        method: "POST",
        headers: buildHeaders(true),
        body: JSON.stringify({ name: trimmed })
      });
      if (!response.ok) {
        throw new Error("Failed to create project");
      }
      const project = await response.json();
      setProjects((prev) => [project, ...prev]);
      setSelectedProjectId(project.id);
      setProjectName("");
      setProjectStatus(`Project "${project.name}" ready.`);
    } catch (error) {
      console.error("LinkCollector: project creation failed", error);
      setProjectStatus("Unable to create project right now.");
    } finally {
      setIsCreatingProject(false);
    }
  };

  const removePendingLink = (index) => {
    const next = [...pendingLinks];
    next.splice(index, 1);
    writeStoredLinks(next);
    setPendingLinks(next);
  };

  const clearPendingLinks = () => {
    writeStoredLinks([]);
    setPendingLinks([]);
  };

  const persistCapture = useCallback(
    async (link) => {
      if (!selectedProjectId) {
        throw new Error("Select a project before saving links.");
      }
      const response = await fetch(
        `${DBAPI_BASE_URL}/projects/${selectedProjectId}/captures`,
        {
          method: "POST",
          headers: buildHeaders(true),
          body: JSON.stringify(mapLinkToCapturePayload(link))
        }
      );
      if (!response.ok) {
        throw new Error("FlexRec API error");
      }
      const created = await response.json();
      setCaptures((prev) => [created, ...prev]);
      return created;
    },
    [selectedProjectId]
  );

  const handleSaveLink = async (link) => {
    if (link.saved) {
      setSaveMessage("Link already saved.");
      return;
    }
    if (!selectedProjectId) {
      setSaveMessage("Select a project before saving links.");
      return;
    }
    setSaveMessage("Saving link to captures...");
    try {
      await persistCapture(link);
      setSaveMessage(`Saved "${link.title}" to captures.`);
    } catch (error) {
      console.error("LinkCollector: single save failed", error);
      setSaveMessage("Unable to save this link at the moment.");
    }
  };

  const handleSaveAll = async () => {
    if (!selectedProjectId) {
      setSaveMessage("Select a project before saving links.");
      return;
    }
    const unsaved = pendingWithStatus.filter((link) => !link.saved);
    if (!unsaved.length) {
      setSaveMessage("All pending links are already saved in captures.");
      return;
    }
    setIsSavingAll(true);
    setSaveMessage("Saving pending links…");
    let saved = 0;
    let failed = 0;
    for (const link of unsaved) {
      try {
        await persistCapture(link);
        saved += 1;
      } catch (error) {
        console.error("LinkCollector: batch save failed", error);
        failed += 1;
      }
    }
    setIsSavingAll(false);
    setSaveMessage(`Saved ${saved} link(s)${failed ? ` (${failed} failed)` : ""}.`);
  };

  const handleProjectUpdate = async (event) => {
    event.preventDefault();
    if (!selectedProjectId) {
      return;
    }
    let parsedMetadata = {};
    try {
      parsedMetadata = projectDraft.metadataJson
        ? JSON.parse(projectDraft.metadataJson)
        : {};
    } catch (error) {
      setProjectStatus("Metadata JSON is invalid.");
      return;
    }
    setProjectStatus("Updating project…");
    try {
      const response = await fetch(`${DBAPI_BASE_URL}/projects/${selectedProjectId}`, {
        method: "PATCH",
        headers: buildHeaders(true),
        body: JSON.stringify({
          name: projectDraft.name.trim(),
          owner_id: projectDraft.ownerId.trim() || null,
          metadata: parsedMetadata
        })
      });
      if (!response.ok) {
        throw new Error("Project update failed");
      }
      const updated = await response.json();
      setProjects((prev) =>
        prev.map((project) => (project.id === updated.id ? updated : project))
      );
      setProjectStatus("Project updated.");
    } catch (error) {
      console.error("LinkCollector: project update failed", error);
      setProjectStatus("Unable to update project.");
    }
  };

  const handleCaptureEditChange = (captureId, field, value) => {
    setCaptureEdits((prev) => ({
      ...prev,
      [captureId]: {
        ...prev[captureId],
        [field]: value
      }
    }));
  };

  const startCaptureEdit = (capture) => {
    setCaptureEdits((prev) => ({
      ...prev,
      [capture.id]: {
        url: capture.url,
        label: capture.label,
        snippet: capture.snippet || "",
        hover_text: capture.hover_text || "",
        source_type: capture.source_type || "",
        category: capture.category || "",
        captured_at: capture.captured_at || ""
      }
    }));
  };

  const cancelCaptureEdit = (captureId) => {
    setCaptureEdits((prev) => {
      const next = { ...prev };
      delete next[captureId];
      return next;
    });
  };

  const saveCaptureEdit = async (captureId) => {
    const edits = captureEdits[captureId];
    if (!edits) return;
    setCaptureSavingId(captureId);
    setCaptureStatus("Saving capture updates…");
    try {
      const response = await fetch(`${DBAPI_BASE_URL}/captures/${captureId}`, {
        method: "PATCH",
        headers: buildHeaders(true),
      body: JSON.stringify({
        url: edits.url,
        label: edits.label,
        snippet: edits.snippet,
        hover_text: edits.hover_text,
        source_type: edits.source_type,
        category: edits.category,
        captured_at: edits.captured_at
      })
    });
      if (!response.ok) {
        throw new Error("Capture update failed");
      }
      const updated = await response.json();
      setCaptures((prev) =>
        prev.map((capture) => (capture.id === updated.id ? updated : capture))
      );
      cancelCaptureEdit(captureId);
      setCaptureStatus("Capture updated.");
    } catch (error) {
      console.error("LinkCollector: capture update failed", error);
      setCaptureStatus("Unable to update capture.");
    } finally {
      setCaptureSavingId(null);
    }
  };

  const handleCvUpload = async () => {
    if (!selectedProjectId || !cvFile) {
      setCvStatus("Select a project and a file before uploading.");
      return;
    }
    const formData = new FormData();
    formData.append("file", cvFile);
    formData.append("project_id", selectedProjectId);
    setCvStatus("Uploading CV…");
    try {
      const response = await fetch(`${DBAPI_BASE_URL}/projects/${selectedProjectId}/cvs`, {
        method: "POST",
        headers: DBAPI_KEY ? { "x-api-key": DBAPI_KEY } : {},
        body: formData
      });
      if (!response.ok) {
        throw new Error("CV upload rejected");
      }
      setCvStatus("CV uploaded successfully.");
      setCvFile(null);
    } catch (error) {
      console.error("LinkCollector: CV upload failed", error);
      setCvStatus("Unable to upload CV right now.");
    }
  };

  const performAction = async () => {
    if (!selectedProjectId) {
      setActionStatus("Select a project before running an action.");
      return;
    }
    setActionLoading(true);
    setActionStatus("Contacting n8n…");
    console.log("POSTing to ACTION_WEBHOOK_URL", ACTION_WEBHOOK_URL, {
      project_id: selectedProjectId,
      action: selectedActivity
    });
    try {
      const response = await fetch(ACTION_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          project_id: selectedProjectId,
          action: selectedActivity
        })
      });
      if (!response.ok) {
        throw new Error(`Webhook returned ${response.status}`);
      }
      const payload = await response.json().catch(() => ({}));
      const body = parseWebhookResponse(payload);
      setActionResult(typeof body === "string" ? body : JSON.stringify(body, null, 2));
      setActionStatus("Action finished. Copy the text below.");
    } catch (error) {
      console.error("LinkCollector: action failed", error);
      setActionStatus("Unable to run action right now.");
    } finally {
      setActionLoading(false);
    }
  };

  const copyText = async (text, setter, label) => {
    if (!navigator?.clipboard) return;
    try {
      await navigator.clipboard.writeText(text);
      setter(label ? `Copied ${label}!` : "Copied!");
      setTimeout(() => setter(""), 1800);
    } catch (error) {
      console.error("LinkCollector: copy failed", error);
    }
  };

  return (
    <div style={styles.pageShell}>
      <div style={styles.header}>
        <div>
          <p style={styles.subheading}>Projects · Scan the Internet · Actions</p>
          <h1 style={styles.title}>Job Finder Workspace</h1>
          <p style={styles.description}>
            Select a FlexRec project, collect links with the bookmarklets, and manage captures plus companion assets in one tabbed view.
          </p>
        </div>
        <div style={styles.topControls}>
          <label style={styles.fieldLabel}>Project</label>
          <select
            value={selectedProjectId}
            onChange={(event) => setSelectedProjectId(event.target.value)}
            style={styles.projectSelect}
          >
            {!projects.length && <option value="">No projects yet</option>}
            {projects.map((project) => (
              <option key={project.id} value={project.id}>
                {project.name}
              </option>
            ))}
          </select>
          <form onSubmit={handleCreateProject} style={styles.projectForm}>
            <input
              placeholder="New project name"
              value={projectName}
              onChange={(event) => setProjectName(event.target.value)}
              style={styles.projectInput}
            />
            <button
              type="submit"
              disabled={!projectName.trim() || isCreatingProject}
              style={styles.projectButton}
            >
              {isCreatingProject ? "Creating…" : "Create"}
            </button>
          </form>
        </div>
      </div>
      {(saveMessage || projectStatus || captureStatus) && (
        <div style={styles.statusBar}>
          <span>{saveMessage || projectStatus || captureStatus}</span>
        </div>
      )}
      <div style={styles.tabBar}>
        {TAB_DEFINITIONS.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            style={{
              ...styles.tabButton,
              ...(activeTab === tab.key ? styles.tabButtonActive : {})
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div style={styles.tabContent}>
        {activeTab === "collection" && (
          <div style={styles.section}>
            <div style={styles.filterRow}>
              <div>
                <label style={styles.fieldLabel}>Platform</label>
                <select
                  style={styles.filterSelect}
                  value={filterSource}
                  onChange={(event) => setFilterSource(event.target.value)}
                >
                  {collectionSources.map((source) => (
                    <option key={source} value={source}>
                      {source === "all" ? "All Platforms" : source}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label style={styles.fieldLabel}>Type</label>
                <select
                  style={styles.filterSelect}
                  value={filterType}
                  onChange={(event) => setFilterType(event.target.value)}
                >
                  {FILTER_TYPES.map((type) => (
                    <option key={type.value} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </select>
              </div>
              <div style={styles.badgeRow}>
                <span style={styles.badge}>{pendingLinks.length} pending</span>
                <span style={styles.badge}>{captures.length} captures</span>
              </div>
            </div>
            <div style={styles.actionRow}>
              <button
                type="button"
                onClick={clearPendingLinks}
                style={{ ...styles.primaryButton, ...styles.dangerButton }}
              >
                Clear pending
              </button>
              <button
                type="button"
                onClick={handleSaveAll}
                disabled={isSavingAll || !pendingWithStatus.length}
                style={styles.primaryButton}
              >
                {isSavingAll ? "Saving…" : "Save all to captures"}
              </button>
            </div>
            <div style={styles.collectionList}>
              {filteredPendingLinks.length ? (
                filteredPendingLinks.map((link, index) => (
                  <div key={`${link.url}-${index}`} style={styles.linkCard}>
                    <div style={styles.linkHeader}>
                      <div>
                        <strong style={styles.linkTitle}>{link.title}</strong>
                        <div style={styles.linkMeta}>
                          {link.source} · {link.type}
                        </div>
                      </div>
                      <span style={link.saved ? styles.savedBadge : styles.unsavedBadge}>
                        {link.saved ? "Saved" : "Unsaved"}
                      </span>
                    </div>
                    <a href={link.url} target="_blank" rel="noreferrer" style={styles.linkUrl}>
                      {link.url}
                    </a>
                    {link.snippet && <p style={styles.snippet}>{link.snippet}</p>}
                    <div style={styles.linkFooter}>
                      <span style={styles.timestamp}>{new Date(link.timestamp).toLocaleString()}</span>
                      <div>
                        <button
                          type="button"
                          onClick={() => removePendingLink(index)}
                          style={styles.secondaryButton}
                        >
                          Remove
                        </button>
                        <button
                          type="button"
                          disabled={link.saved || !selectedProjectId}
                          onClick={() => handleSaveLink(link)}
                          style={styles.primaryButton}
                        >
                          {link.saved ? "Saved" : "Save to captures"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div style={styles.emptyState}>
                  <p>No pending links. Run a bookmarklet and send data to this workspace.</p>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "captures" && (
          <div style={styles.section}>
            <div style={styles.projectEditor}>
              <h3>Project details</h3>
              <form onSubmit={handleProjectUpdate} style={styles.projectEditorForm}>
                <div style={styles.formRow}>
                  <label style={styles.fieldLabel}>Name</label>
                  <input
                    value={projectDraft.name}
                    onChange={(event) =>
                      setProjectDraft((prev) => ({ ...prev, name: event.target.value }))
                    }
                    disabled={!selectedProjectId}
                    style={styles.fullInput}
                  />
                </div>
                <div style={styles.formRow}>
                  <label style={styles.fieldLabel}>Owner ID</label>
                  <input
                    value={projectDraft.ownerId}
                    onChange={(event) =>
                      setProjectDraft((prev) => ({ ...prev, ownerId: event.target.value }))
                    }
                    disabled={!selectedProjectId}
                    style={styles.fullInput}
                  />
                </div>
                <div style={styles.formRow}>
                  <label style={styles.fieldLabel}>Metadata (JSON)</label>
                  <textarea
                    value={projectDraft.metadataJson}
                    onChange={(event) =>
                      setProjectDraft((prev) => ({ ...prev, metadataJson: event.target.value }))
                    }
                    disabled={!selectedProjectId}
                    rows={3}
                    style={styles.fullTextarea}
                  />
                </div>
                <button
                  type="submit"
                  disabled={!selectedProjectId}
                  style={styles.primaryButton}
                >
                  Update project
                </button>
              </form>
            </div>
            <div style={styles.captureFilters}>
              {captureSourceTabs.map((source) => (
                <button
                  key={source}
                  type="button"
                  onClick={() => setActiveCaptureSource(source)}
                  style={{
                    ...styles.sourceTab,
                    ...(activeCaptureSource === source ? styles.sourceTabActive : {})
                  }}
                >
                  {source === "all" ? "All sources" : source}
                </button>
              ))}
            </div>
            <div style={styles.captureList}>
              {filteredCaptures.length ? (
                filteredCaptures.map((capture) => {
                  const editing = !!captureEdits[capture.id];
                  const editValues = captureEdits[capture.id] || {}; 
                  return (
                    <div key={capture.id} style={styles.captureCard}>
                      <div style={styles.captureHeader}>
                        <div>
                          <strong>{capture.label}</strong>
                          <div style={styles.captureMeta}>
                            {capture.source_type || "Captured link"} · {new Date(
                              capture.captured_at
                            ).toLocaleString()}
                          </div>
                          {capture.category && (
                            <div style={styles.captureCategory}>
                              Category: {capture.category}
                            </div>
                          )}
                        </div>
                        <div style={styles.captureActions}>
                          {editing ? (
                            <>
                              <button
                                type="button"
                                onClick={() => saveCaptureEdit(capture.id)}
                                disabled={captureSavingId === capture.id}
                                style={styles.primaryButton}
                              >
                                {captureSavingId === capture.id ? "Saving…" : "Save"}
                              </button>
                              <button
                                type="button"
                                onClick={() => cancelCaptureEdit(capture.id)}
                                style={styles.secondaryButton}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <button
                              type="button"
                              onClick={() => startCaptureEdit(capture)}
                              style={styles.secondaryButton}
                            >
                              Edit
                            </button>
                          )}
                        </div>
                      </div>
                      <a href={capture.url} target="_blank" rel="noreferrer" style={styles.linkUrl}>
                        {capture.url}
                      </a>
                      {editing ? (
                        <div style={styles.captureEditGrid}>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Label</label>
                            <input
                              value={editValues.label}
                              onChange={(event) =>
                                handleCaptureEditChange(capture.id, "label", event.target.value)
                              }
                              style={styles.fullInput}
                            />
                          </div>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Source type</label>
                            <input
                              value={editValues.source_type}
                              onChange={(event) =>
                                handleCaptureEditChange(capture.id, "source_type", event.target.value)
                              }
                              style={styles.fullInput}
                            />
                          </div>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Category</label>
                            <input
                              value={editValues.category}
                              onChange={(event) =>
                                handleCaptureEditChange(capture.id, "category", event.target.value)
                              }
                              style={styles.fullInput}
                            />
                          </div>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Captured at</label>
                            <input
                              type="datetime-local"
                              value={formatToLocalDateTime(editValues.captured_at)}
                              onChange={(event) =>
                                handleCaptureEditChange(
                                  capture.id,
                                  "captured_at",
                                  event.target.value ? new Date(event.target.value).toISOString() : ""
                                )
                              }
                              style={styles.fullInput}
                            />
                          </div>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Snippet</label>
                            <textarea
                              value={editValues.snippet}
                              onChange={(event) =>
                                handleCaptureEditChange(capture.id, "snippet", event.target.value)
                              }
                              rows={2}
                              style={styles.fullTextarea}
                            />
                          </div>
                          <div style={styles.editRow}>
                            <label style={styles.fieldLabel}>Hover text</label>
                            <input
                              value={editValues.hover_text}
                              onChange={(event) =>
                                handleCaptureEditChange(capture.id, "hover_text", event.target.value)
                              }
                              style={styles.fullInput}
                            />
                          </div>
                        </div>
                      ) : (
                        <div style={styles.captureBody}>
                          {capture.snippet && <p style={styles.snippet}>{capture.snippet}</p>}
                          {capture.hover_text && (
                            <p style={styles.hoverText}>Hover text: {capture.hover_text}</p>
                          )}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <div style={styles.emptyState}>
                  <p>No captures yet for this project.</p>
                </div>
              )}
            </div>
          </div>
        )}

        {activeTab === "cv" && (
          <div style={styles.section}>
            <div style={styles.cvSection}>
              <h3>Upload CV</h3>
              <p style={styles.description}>
                Attach a resume or CV and link it to the currently selected project. The backend
                needs the CV table in place for this to persist.
              </p>
              <input
                type="file"
                accept=".pdf,.doc,.docx"
                onChange={(event) => setCvFile(event.target.files?.[0] || null)}
                style={styles.fileInput}
              />
              <button
                type="button"
                onClick={handleCvUpload}
                disabled={!cvFile || !selectedProjectId}
                style={styles.primaryButton}
              >
                Upload CV
              </button>
              {cvStatus && <p style={styles.statusText}>{cvStatus}</p>}
            </div>
            <div style={styles.actionSection}>
              <h3>Perform an action</h3>
              <div style={styles.actionControls}>
                <select
                  value={selectedActivity}
                  onChange={(event) => setSelectedActivity(event.target.value)}
                  style={styles.filterSelect}
                >
                  {ACTIVITY_OPTIONS.map((activity) => (
                    <option key={activity.value} value={activity.value}>
                      {activity.label}
                    </option>
                  ))}
                </select>
                <button
                  type="button"
                  onClick={performAction}
                  disabled={actionLoading || !selectedProjectId}
                  style={styles.primaryButton}
                >
                  {actionLoading ? "Running…" : "Perform Action"}
                </button>
              </div>
              {actionStatus && <p style={styles.statusText}>{actionStatus}</p>}
              <div style={styles.actionResultBox}>
                {actionResult ? (
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm]}
                    components={{
                      code({ node, inline, className, children, ...props }) {
                        return inline ? (
                          <code style={styles.inlineCode} {...props}>
                            {children}
                          </code>
                        ) : (
                          <pre style={styles.codeBlock} {...props}>
                            {children}
                          </pre>
                        );
                      }
                    }}
                  >
                    {actionResult}
                  </ReactMarkdown>
                ) : (
                  <p style={styles.actionResultText}>Action output will show up here.</p>
                )}
              </div>
              {actionResult && (
                <button
                  type="button"
                  onClick={() => copyText(actionResult, setActionStatus)}
                  style={styles.secondaryButton}
                >
                  Copy result
                </button>
              )}
            </div>
          </div>
        )}

        {activeTab === "instructions" && (
          <div style={styles.section}>
            <div style={styles.instructions}>
              <h3>How to use this page</h3>
              <ol style={styles.instructionList}>
                <li>Select or create a project at the top and keep it active across tabs.</li>
                <li>
                  Run any of the bookmarklets and choose links on the source site; each selection is
                  stored locally until you save it to the captures table.
                </li>
                <li>
                  Tab 2 lets you edit project metadata, review captures per source, and tweak the
                  captured record attributes before pushing changes.
                </li>
                <li>Tab 3 accepts CV uploads and triggers n8n actions tied to the project.</li>
                <li>The instructions below also remind you to copy the bookmarklet code into your
                  toolbar.</li>
              </ol>
            </div>
            <div style={styles.bookmarkletList}>
              {BOOKMARKLETS.map((bookmarklet) => {
                const normalized = normalizeBookmarkletCode(bookmarklet.code);
                return (
                  <div key={bookmarklet.title} style={styles.bookmarkletCard}>
                    <div>
                      <strong>{bookmarklet.title}</strong>
                      <p style={styles.snippet}>{bookmarklet.description}</p>
                    </div>
                    <div style={styles.bookmarkletCodeWrapper}>
                      <code style={styles.bookmarkletCode}>{normalized}</code>
                      <button
                        type="button"
                        onClick={() => copyText(normalized, setCopiedBookmarklet, bookmarklet.title)}
                        style={styles.secondaryButton}
                      >
                        {copiedBookmarklet === bookmarklet.title ? "Copied!" : "Copy code"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  pageShell: {
    padding: 32,
    color: "#f4f5ff",
    background: "#05060f",
    minHeight: "100vh",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 24,
    marginBottom: 12
  },
  subheading: {
    margin: 0,
    fontSize: 12,
    letterSpacing: 1.2,
    textTransform: "uppercase",
    color: "rgba(255,255,255,0.6)"
  },
  title: {
    margin: "4px 0",
    fontSize: 32
  },
  description: {
    margin: 0,
    color: "rgba(255,255,255,0.7)",
    maxWidth: 480
  },
  topControls: {
    display: "flex",
    flexDirection: "column",
    gap: 8
  },
  fieldLabel: {
    display: "block",
    fontSize: 12,
    color: "rgba(255,255,255,0.7)",
    marginBottom: 4
  },
  projectSelect: {
    padding: "8px 12px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.04)",
    color: "white"
  },
  projectForm: {
    display: "flex",
    gap: 6
  },
  projectInput: {
    padding: "8px 12px",
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.04)",
    color: "white",
    flex: 1
  },
  projectButton: {
    padding: "8px 16px",
    borderRadius: 10,
    border: "none",
    background: "#7c4dff",
    color: "white",
    cursor: "pointer"
  },
  statusBar: {
    marginTop: 8,
    padding: 12,
    borderRadius: 10,
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.15)"
  },
  tabBar: {
    display: "flex",
    gap: 12,
    marginTop: 16,
    flexWrap: "wrap"
  },
  tabButton: {
    padding: "10px 20px",
    borderRadius: 999,
    border: "1px solid transparent",
    background: "rgba(255,255,255,0.08)",
    color: "white",
    cursor: "pointer"
  },
  tabButtonActive: {
    borderColor: "#7c4dff",
    background: "rgba(124,77,255,0.2)"
  },
  tabContent: {
    marginTop: 20
  },
  section: {
    background: "rgba(255,255,255,0.02)",
    borderRadius: 18,
    padding: 24,
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 20px 40px rgba(0,0,0,0.35)"
  },
  filterRow: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    alignItems: "center",
    marginBottom: 12
  },
  filterSelect: {
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.05)",
    color: "white"
  },
  badgeRow: {
    display: "flex",
    gap: 8
  },
  badge: {
    background: "rgba(124,77,255,0.2)",
    color: "white",
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 12
  },
  actionRow: {
    display: "flex",
    gap: 12,
    marginBottom: 12
  },
  primaryButton: {
    background: "#4285f4",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: 8,
    cursor: "pointer"
  },
  secondaryButton: {
    background: "rgba(255,255,255,0.08)",
    color: "white",
    border: "1px solid rgba(255,255,255,0.2)",
    padding: "6px 14px",
    borderRadius: 8,
    cursor: "pointer",
    marginLeft: 8
  },
  dangerButton: {
    background: "#ea4335"
  },
  collectionList: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
    marginTop: 12
  },
  linkCard: {
    padding: 16,
    borderRadius: 12,
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,255,255,0.12)"
  },
  linkHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6
  },
  linkTitle: {
    fontSize: 16
  },
  linkMeta: {
    fontSize: 12,
    color: "rgba(255,255,255,0.6)"
  },
  savedBadge: {
    background: "#34a853",
    color: "white",
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 11
  },
  unsavedBadge: {
    background: "rgba(255,255,255,0.1)",
    color: "white",
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 11
  },
  linkUrl: {
    color: "#b86fff",
    textDecoration: "none",
    fontSize: 14
  },
  snippet: {
    color: "rgba(255,255,255,0.7)",
    margin: "8px 0"
  },
  linkFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 8
  },
  timestamp: {
    color: "rgba(255,255,255,0.5)",
    fontSize: 12
  },
  emptyState: {
    padding: 24,
    borderRadius: 12,
    border: "1px dashed rgba(255,255,255,0.3)",
    color: "rgba(255,255,255,0.6)",
    textAlign: "center"
  },
  sourceTabs: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginTop: 20,
    marginBottom: 12
  },
  captureFilters: {
    display: "flex",
    gap: 8,
    flexWrap: "wrap",
    marginBottom: 12
  },
  sourceTab: {
    padding: "6px 12px",
    borderRadius: 6,
    background: "rgba(255,255,255,0.08)",
    border: "1px solid transparent",
    color: "white",
    cursor: "pointer"
  },
  sourceTabActive: {
    borderColor: "rgba(124,77,255,0.5)",
    background: "rgba(124,77,255,0.2)"
  },
  captureList: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 12
  },
  captureCard: {
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.12)",
    padding: 16,
    background: "rgba(255,255,255,0.02)"
  },
  captureHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6
  },
  captureMeta: {
    fontSize: 12,
    color: "rgba(255,255,255,0.6)"
  },
  captureCategory: {
    fontSize: 12,
    color: "rgba(255,255,255,0.5)",
    marginTop: 4
  },
  captureActions: {
    display: "flex",
    gap: 8
  },
  projectEditor: {
    marginBottom: 20
  },
  projectEditorForm: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  formRow: {
    display: "flex",
    flexDirection: "column",
    gap: 4
  },
  fullInput: {
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.04)",
    color: "white"
  },
  fullTextarea: {
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid rgba(255,255,255,0.2)",
    background: "rgba(255,255,255,0.04)",
    color: "white"
  },
  captureBody: {
    marginTop: 8
  },
  hoverText: {
    margin: 0,
    fontSize: 13,
    color: "rgba(255,255,255,0.6)"
  },
  captureEditGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: 12,
    marginTop: 12
  },
  editRow: {
    display: "flex",
    flexDirection: "column",
    gap: 4
  },
  cvSection: {
    marginBottom: 20,
    padding: 16,
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.03)"
  },
  fileInput: {
    margin: "10px 0"
  },
  actionSection: {
    padding: 16,
    borderRadius: 12,
    border: "1px solid rgba(255,255,255,0.1)",
    background: "rgba(255,255,255,0.03)"
  },
  actionControls: {
    display: "flex",
    gap: 12,
    alignItems: "center",
    marginBottom: 12,
    flexWrap: "wrap"
  },
  actionResultBox: {
    padding: 12,
    borderRadius: 10,
    background: "rgba(0,0,0,0.4)",
    border: "1px solid rgba(255,255,255,0.1)",
    minHeight: 120,
    marginBottom: 12
  },
  actionResultText: {
    margin: 0,
    fontSize: 13,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word"
  },
  instructions: {
    marginBottom: 18
  },
  instructionList: {
    paddingLeft: 20,
    color: "rgba(255,255,255,0.8)",
    fontSize: 14
  },
  bookmarkletList: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  bookmarkletCard: {
    borderRadius: 10,
    border: "1px solid rgba(255,255,255,0.1)",
    padding: 16,
    background: "rgba(255,255,255,0.03)"
  },
  bookmarkletCodeWrapper: {
    marginTop: 10,
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    flexWrap: "wrap"
  },
  bookmarkletCode: {
    flex: 1,
    fontSize: 12,
    background: "rgba(0,0,0,0.4)",
    padding: "8px 10px",
    borderRadius: 8,
    display: "inline-block",
    overflowX: "auto",
    whiteSpace: "nowrap"
  },
  statusText: {
    marginTop: 8,
    fontSize: 13,
    color: "rgba(255,255,255,0.75)"
  }
};

styles.inlineCode = {
  background: "rgba(0,0,0,0.4)",
  borderRadius: 4,
  padding: "2px 4px"
};

styles.codeBlock = {
  background: "rgba(0,0,0,0.35)",
  padding: "10px",
  borderRadius: 8,
  overflowX: "auto",
  fontSize: 13
};

export default FindJobsPage;
